module.exports = __webpack_public_path__ + "img/20191108154941360截图20191108145944549.b0ddcd29.jpg";